import { InAppContentDefinition, MESSAGE_FORMAT } from 'modules/graphql/types';
import { RawDataForm } from 'modules/templateEditor/common/RawDataForm';

import { useEditableFieldsContext } from '../../context/EditableFieldsContext';

export const RawDataFormSection = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { messageFormat } = (liveTemplate?.mediumData || {}) as InAppContentDefinition;

  return <>{messageFormat !== MESSAGE_FORMAT.Html && <RawDataForm />}</>;
};
